import { createContext } from 'react';

export const NotificationUpdateContex = createContext<{
  notificationUpdate: any;
  setNotificationUpdate: any;
}>({ notificationUpdate: null, setNotificationUpdate: () => {} });
